import {
  ADDON_STATUS,
  TypeAddonKind,
  TypeAddonPreferenceRecord,
  TypeScheduledAddOnRecord,
  TypeScheduledItemRecord,
  TypeSubscriptionRecord,
} from '@/lib/api/subscriptionManager/types';

export function isSubscriptionAddonActive(
  subscription: TypeSubscriptionRecord,
  subscriptionAddOnKind: TypeAddonKind,
) {
  const isSelectedAddOnActive = (
    addon: TypeScheduledAddOnRecord | TypeAddonPreferenceRecord,
  ) =>
    addon.addon_kind === subscriptionAddOnKind &&
    addon.addon_status === ADDON_STATUS.ACTIVE;

  return subscription.addon_preferences?.some(isSelectedAddOnActive) || false;
}

export function anyActiveSubscriptionAddons(
  subscription: TypeSubscriptionRecord,
) {
  return subscription.addon_preferences?.some((addon) =>
    isSubscriptionAddonActive(subscription, addon.addon_kind),
  );
}

export function getSubscriptionAddons(subscription: TypeSubscriptionRecord) {
  // subscription records created prior to book bundle launch won't have addons defined,
  // we need to honor this case
  if (!subscription.addon_preferences) return [];

  return subscription.addon_preferences;
}

export function isScheduledItemAddonActive(
  scheduledItem: TypeScheduledItemRecord,
  subscriptionAddOnKind: TypeAddonKind,
) {
  const isSelectedAddOnActive = (addon: TypeScheduledAddOnRecord) =>
    addon.addon_kind === subscriptionAddOnKind &&
    addon.addon_status === ADDON_STATUS.ACTIVE;

  return scheduledItem.scheduled_addons?.some(isSelectedAddOnActive);
}

export function doesScheduledItemHaveADelightItem(
  scheduledItem: TypeScheduledItemRecord,
) {
  return scheduledItem.delight_item_addons?.length;
}

export function doesScheduledItemHaveAddOns(
  scheduledItem: TypeScheduledItemRecord,
) {
  return scheduledItem.scheduled_addons?.length;
}
